const HistoryRoute = [
  {
    path: '/history',
    name: 'History',
    component: () => import('../../views/History/Index.vue'),
  },
];

export default HistoryRoute;
